module.exports = __webpack_public_path__ + "assets/images/coin-25.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-25.png
// module id = 1505
// module chunks = 1